import {
  ArrayField,
  Datagrid,
  EditButton,
  ListButton,
  SelectField,
  Show,
  TabbedShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

import { DateFieldWithStandardFormat } from "@/fields/DateFieldWithStandardFormat";

const ShowActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <EditButton />
  </TopToolbar>
);

export const LandingsShow = () => (
  <Show actions={<ShowActions />}>
    <TabbedShowLayout>
      <TabbedShowLayout.Tab label="Landing">
        <TextField source="title" label="Landing Title:" />
        <TextField source="appLandingId" label="App Landing ID:" />
        <TextField source="showAcceptPrivacy" label="Show Accept Privacy:" />
        <DateFieldWithStandardFormat source="createdAt" label="CreatedAt:" />
        <DateFieldWithStandardFormat source="updatedAt" label="UpdatedAt:" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Attributes">
        <ArrayField source="attributes">
          <Datagrid bulkActionButtons={false}>
            <SelectField
              source="groupName"
              label="Group Name:"
              choices={[{ id: "subscription", name: "subscription" }]}
            />
            <TextField source="content" label="Content:" />
          </Datagrid>
        </ArrayField>
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  </Show>
);
